import { companyagreementApi } from 'app/src/services/welfareportal'
import { BreadCrumbClickableItemTemplate } from 'app/src/shared/components'

export function CatalogCategoryBreadcrumbItem(props: { categoryId: string; command?: () => void }) {
  const category = companyagreementApi.useCategoryGet<companyagreementApi.Category>({
    pathParams: {
      categoryId: props.categoryId,
    },
  })

  return (
    category.data &&
    BreadCrumbClickableItemTemplate({
      label: category.data?.categoryName,
      command: props.command,
    })
  )
}
